import React from 'react';
import {SafeAreaView, ScrollView, View} from 'react-native';
import {Screen} from 'react-native-screens';
import Spinner from 'react-native-loading-spinner-overlay';
// import {CircularProgress} from 'src/design-system';
import {Error, Separator, Success} from 'src/common-components/atoms';
import SVG from 'src/styles/svg';
import {useStyle} from 'src/providers/style';
import {Colors, Typography} from 'src/styles';

interface BaseAuthScreenProps {
  children?: any;
  loading?: boolean;
  toast?: any;
  // syncProgress?: number;
}

const BaseAuthScreen = ({
  children,
  loading = false,
  toast = null,
}: // syncProgress = 0,
BaseAuthScreenProps) => {
  const styles = useStyle();

  return (
    <Screen
      style={[
        styles.flex,
        styles.width,
        styles.height,
        styles.backgroundColorWhite,
        styles.column,
        styles.alignCenter,
        styles.justifyCenter,
      ]}>
      <SafeAreaView
        style={[
          styles.flex,
          styles.width,
          styles.height,
          styles.backgroundColorWhite,
          styles.column,
          styles.alignCenter,
          styles.justifyCenter,
        ]}>
        <Spinner
          visible={loading}
          textContent={
            'Please wait while the page loads completely to ensure proper data syncing. Thank you for your patience!'
          }
          overlayColor={Colors.OPACITY_54}
          textStyle={[
            styles.textColorWhite,
            Typography.P2_MEDIUM,
            styles.paddingHorizontal,
            styles.height200,
            styles.maxWindowWidth90,
            /* eslint-disable-next-line react-native/no-inline-styles */
            {marginTop: 90},
          ]}
          // TODO: Add this back once sync progress is visible
          // customIndicator={
          //   <View
          //     style={[
          //       styles.card,
          //       styles.justifyCenter,
          //       styles.alignCenter,
          //       styles.padding,
          //     ]}>
          //     <View style={[styles.paddingTop]}>
          //       <CircularProgress progress={syncProgress} variant={'linear'} />
          //     </View>
          // <View style={[styles.padding]}>
          //   <Text style={[Typography.P3]}>
          //     Please wait while the page loads completely to ensure proper
          //     data syncing. Thank you for your patience!
          //   </Text>
          // </View>
          //   </View>
          // }
        />
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={[styles.width, styles.maxWidth540]}
          contentContainerStyle={[styles.width, styles.maxWidth540]}
          bounces={false}>
          <View
            style={[
              styles.borderRadius,
              styles.column,
              styles.paddingHorizontal,
              styles.paddingVertical,
              styles.width,
              styles.maxWidth540,
            ]}>
            <View
              style={[
                styles.width,
                styles.alignCenter,
                styles.justifyCenter,
                styles.paddingBottom,
              ]}>
              <SVG height={45} name={'logo'} />
            </View>
            {toast && toast.success ? (
              <Success title={toast.title} message={toast.message} />
            ) : toast && !toast.success ? (
              <Error title={toast.title} message={toast.message} />
            ) : (
              <></>
            )}
            {toast ? <Separator height={20} /> : <></>}
            {children}
          </View>
        </ScrollView>
      </SafeAreaView>
    </Screen>
  );
};

export default BaseAuthScreen;
